var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvioncito(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182.04 95.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3662c1;}.cls-2{fill:#9bb8f5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AVIONCITO2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "101.17 83.56 0 31.43 90.47 33.17 84.11 48.69 103.58 68.6 101.17 83.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 31.43 104.44 46.3 182.04 95.73 0 31.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "90.47 33.17 0 31.43 93.31 0 90.47 33.17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvioncito);
export default __webpack_public_path__ + "static/media/avioncito.a4150e6745e367f8d8e02fc3b9bf88c3.svg";
export { ForwardRef as ReactComponent };